/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
const React = require('react');
const PropTypes = require('prop-types');
const Card = require('@andes/card');
const { CardContent } = require('@andes/card');
const { Link } = require('frontend-spa');
const MenuUtils = require('../../../../../utils/menu');
const { sanitizePath } = require('../../../../common/URLSanitizer');
const { getEventTracker } = require('../../../../../utils/event-tracker');

function PluginCard(props) {
  const { lang, platform, setActiveItem, pluginLink, title, text, image, visible } = props;
  const path = `/developers/${lang}/guides/plugins${pluginLink}`;
  const Tracker = getEventTracker();

  return visible && (
    <Card className="plugins__card" animated>
      <Link
        to={`/developers/${lang}/guides/plugins${pluginLink}`}
        onClick={() => { Tracker.send(`mpdevelopers/click_plugins_landing_${title}`); setActiveItem(MenuUtils.getItemFromURLParent(sanitizePath(path), platform.siteId.toLowerCase(), lang)); }}
      >
        <CardContent className="card-content">
          <div className="plugins-secondary-card__image">
            {image}
          </div>
          <div className="plugins-secondary-card__text">
            <h3>{title}</h3>
            <p>{text}.</p>
          </div>
        </CardContent>
      </Link>
    </Card>
  );
}

PluginCard.propTypes = {
  platform: PropTypes.shape({
    siteId: PropTypes.string,
  }).isRequired,
  visible: PropTypes.shape({
    siteId: PropTypes.bool,
  }),
  lang: PropTypes.string.isRequired,
  setActiveItem: PropTypes.func.isRequired,
  pluginLink: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

PluginCard.defaultProps = {
  visible: true,
};

module.exports = PluginCard;
